import React, { useEffect, useState } from 'react';
import { useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import PropTypes from 'prop-types';
import FacetCount from '../FacetCount';
import { noPrice } from '../../global-constants';

const NoPriceButton = ({
	id,
	noPriceCount,
	noPriceLabel,
	isDisabled,
	isSelected,
	selectedValues,
	facetTitle
}) => {
	const { widgetName, windowId } = useRequestData();
	const [isActive, setActive] = useState(isSelected);
	useEffect(() => {
		setActive(isSelected);
	}, [isSelected]);

	/**
	 * This function calls the setFilterSelections method to update the url with vehicles with no price
	 * It will also removes vehicles with no price when appropriate.
	 */
	const toggleNoPrices = () => {
		setActive(!isActive);
		const updatedSelections = [];
		selectedValues.map((selected) =>
			updatedSelections.push(selected.value)
		);

		if (isActive) {
			updatedSelections.splice(updatedSelections.indexOf(noPrice), 1);
		} else {
			updatedSelections.push(noPrice);
		}
		window.DDC.InvData.setFilterSelections({
			filterName: id,
			filterValues: updatedSelections,
			filterValue: updatedSelections[0],
			filterTitleText: facetTitle,
			element: document.getElementById(id),
			isSelected: true,
			isSlider: true,
			isChip: false
		});
		trackEvent(widgetName, windowId, {
			action: 'applied',
			element: `${id} selection`,
			elementCTA: 'Include "No Price Available"',
			result: 'Results updated with facet added'
		});
	};

	return (
		<span className="no-price-btn checkbox">
			<label
				htmlFor={`${id}-includeNoPrice`}
				className={isDisabled ? 'disabled' : null}
			>
				<input
					type="checkbox"
					name="no-price-btn"
					value={noPriceLabel}
					id={`${id}-includeNoPrice`}
					onChange={toggleNoPrices}
					disabled={isDisabled}
					checked={isActive}
				/>
				<span className="facet-list-facet-label-text-container">
					<span>{noPriceLabel}</span>
					{noPriceCount && <FacetCount count={noPriceCount} />}
				</span>
			</label>
		</span>
	);
};

NoPriceButton.propTypes = {
	id: PropTypes.string.isRequired,
	isSelected: PropTypes.bool.isRequired,
	noPriceCount: PropTypes.number.isRequired,
	noPriceLabel: PropTypes.string.isRequired,
	selectedValues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	isDisabled: PropTypes.bool.isRequired,
	facetTitle: PropTypes.string
};

export default NoPriceButton;
